import { combineReducers } from "redux";
import authReducer from "./authReducer";
// import errorReducer from "./errorReducers";

import currentUser from './currentUser';

export default combineReducers({
    auth: authReducer,
    currentUser,
});